import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Card,
  CardActions,
  Grid,
  IconButton,
  SvgIcon,
  Tooltip,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import GetAppIcon from '@material-ui/icons/GetApp';
import last from 'lodash/last';
import FileThumbnail from './FileThumbnail';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
    justifyContent: 'space-between',
    marginTop: '0px',
    border: `2px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    boxShadow: 'none',
    cursor: 'pointer',

    '&:hover': {
      backgroundColor: theme.palette.divider
    }
  },
  actionsRoot: {
    display: 'flex'
  },
  card: {
    marginLeft: theme.spacing(2),
    flexGrow: 1,
    display: 'flex',
    padding: theme.spacing(2),
    width: '100%',
    alignItems: 'center'
  },
  cardFileName: {
    flexGrow: 1,
    display: 'flex',
    width: '100%'
  },
  media: {
    height: 240
  },
  placeholder: {
    height: 240,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  insertDriveFileIcon: {
    height: theme.spacing(6),
    width: theme.spacing(6),
    fontSize: theme.spacing(6)
  },
  content: {
    display: 'flex',
    justifyContent: 'space-between',
    width: 250
  },
  getAppIcon: {
    marignRight: theme.spacing(1),
    color: theme.palette.text.primary
  },
  menu: {
    width: 250,
    maxWidth: '100%'
  },
  fileIcon: {
    marginRight: theme.spacing(1.5),
    maxWidth: 90,
    height: 50,
    display: 'flex',
    alignItems: 'center'
  },
  downloadIcon: {
    float: 'right',
    marginLeft: theme.spacing(1),
  },
  activeAppIcon: {
    color: theme.palette.secondary.main
  },
  pdfThumbnail: {
    overflow: 'hidden'
  }
}));

function FileCard({ file, className, onClick, ...rest }) {
  const classes = useStyles();

  const fileExtension = file.claimDocumentName.split('.').at(-1);

  return (
    <Card className={clsx(classes.root, className)} {...rest}>
      <CardActions>
        <Box width="100%">
          <Grid container spacing={2} direction="row" alignItems="center">
            <Grid item xs={11} onClick={onClick}>
              <Box display="flex" alignItems="center">
                <Box className={classes.fileIcon}>
                  <FileThumbnail
                    fileSrc={file.thumbnailSrc}
                    fileType={fileExtension}
                  />
                </Box>
                <Typography variant="subtitle1" color="textPrimary" >
                  {last(file?.claimDocumentName?.split('__'))}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={1}>
              <Tooltip title="Download" className={classes.downloadIcon}>
                <a href={file.blobSrc} without rel="noopener noreferrer" target="_blank">
                  <IconButton
                    size="small"
                    edge="end"
                  >
                    <SvgIcon>
                      <GetAppIcon
                        className={clsx({
                          [classes.getAppIcon]: true,
                        })}
                      />
                    </SvgIcon>
                  </IconButton>
                </a>
              </Tooltip>
            </Grid>
          </Grid>
          <div>
            <Typography color="textPrimary">{file?.comment}</Typography>
          </div>
        </Box>
      </CardActions>
    </Card>
  );
}

FileCard.propTypes = {
  className: PropTypes.string,
  file: PropTypes.object.isRequired,
  onClick: PropTypes.func,
};

export default FileCard;
